document.addEventListener("DOMContentLoaded", function() {
    const options = {
      root: null,
      threshold: 0.5
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slideshow__image-wrapper_active');
        } else {
          entry.target.classList.remove('slideshow__image-wrapper_active');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, options);

    document.querySelectorAll('.slideshow').forEach(section => {
      observer.observe(section);
    });
  });